import isDev from 'utils/isDev'
import configureAnalyticsProvider from 'helpers/configureAnalyticsProvider'
import { propsPresets } from '@iq-firebolt/br-addons'

export const partnerConfig = {
  partnerName: 'Bb Ourocard',
  partnerSlug: 'bb-ourocard',
  experienceType: 'credit',
  partnerLogo: 'images/partner-logo/bb-ourocard.svg',
  sortingHat: {
    workflowId: 'iq-bb-tree',
  },
  firebolt: {
    formAccess: {
      root: isDev
        ? 'https://dsv-firebolt-api.iq.com.br/'
        : 'https://firebolt-api.iq.com.br/',
      formName: 'bb',
    },
    debug: isDev,
    stepQueryParam: 'passo',
    withHistory: true,
    addons: { uiPropsPresets: [propsPresets] },
  },
  tracking: {
    brand: 'bb',
    type: 'partner',
    version: 'v1',
    placement: 'Full Screen',
    identityRequested: true,
  },
}

export const withAnalyticsProvider = configureAnalyticsProvider(
  partnerConfig.partnerName,
  partnerConfig.experienceType,
  {
    ...partnerConfig.tracking,
    slug: partnerConfig.partnerSlug,
  }
)
